import React from 'react';
import Box from '@material-ui/core/Box';
import OtherTopicsItem from './other-topics-item';

const OtherTopics = ({topics, theme}) => {
    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start" px={3}>
            { topics.map((topic, index) => (
                <OtherTopicsItem value={topic.name} key={index} theme={theme} percent={topic.percent} />
            )) }
        </Box>
    )
}

export default OtherTopics;
